import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Package } from "lucide-react";
import { T } from "@/lib/i18n";
import { analyzeQuota, bundleCheckout } from "@/lib/api";

export const ScanCreditsCard = () => {
  const [q, setQ] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { analyzeQuota().then(setQ).catch(() => {}); }, []);
  if (!q?.bundle || q.unlimited) return null;
  const buy = async () => {
    setBusy(true);
    try { window.location.href = (await bundleCheckout()).checkout_url; } catch (e) {
      toast.error(e?.response?.data?.detail || T("Errore pagamento", "Payment error"));
      setBusy(false);
    }
  };
  return (
    <div data-testid="scan-credits-card" className="border border-[#e4e4e7] bg-white p-6 flex flex-wrap items-center justify-between gap-4">
      <div>
        <div className="text-[10px] uppercase tracking-widest font-mono text-[#71717a]">{T("Analisi SEO prepagate", "Prepaid SEO analyses")}</div>
        <div className="mt-1 font-display text-3xl"><span data-testid="scan-credits-count">{q.credits || 0}</span> <span className="text-base text-[#71717a]">{T("analisi disponibili", "analyses available")}</span></div>
        {q.next_expiry && <div className="text-xs font-mono text-[#71717a]">{T("Prima scadenza:", "First expiry:")} {new Date(q.next_expiry).toLocaleDateString("it-CH")}</div>}
      </div>
      <button type="button" data-testid="scan-credits-buy" onClick={buy} disabled={busy}
        className="h-11 px-5 bg-[#09090b] text-white font-medium inline-flex items-center gap-2 hover:bg-[#E0262C] transition-colors disabled:opacity-60">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Package className="w-4 h-4" />}
        {T(`${q.bundle.scans} analisi a CHF ${q.bundle.price}`, `${q.bundle.scans} analyses for CHF ${q.bundle.price}`)}
      </button>
    </div>
  );
};
